"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
var lodash_1 = require("lodash");
var nanoid_1 = require("nanoid");
var types_1 = require("./types");
var MAX_TYPE_FREQUENCY_INCREMENT = 100;
function reducer(state, action) {
    if (action.type === types_1.LineOfCoverageDetailsEditorActionType.ADD_LINES_OF_COVERAGE_DETAILS) {
        var lineOfCoverageDetailsRecords = state.lineOfCoverageDetailsRecords, lineOfCoverageTypeFrequencyMap = state.lineOfCoverageTypeFrequencyMap, lineOfCoverageTypeDisplayNameMap = state.lineOfCoverageTypeDisplayNameMap;
        var linesOfCoverageDetails = action.payload.linesOfCoverageDetails;
        var newLineOfCoverageDetailsRecords = getNewLineOfCoverageDetailsRecords(linesOfCoverageDetails, lineOfCoverageTypeFrequencyMap, lineOfCoverageTypeDisplayNameMap);
        return __assign(__assign({}, state), { lineOfCoverageTypeFrequencyMap: lineOfCoverageTypeFrequencyMap, lineOfCoverageTypeDisplayNameMap: lineOfCoverageTypeDisplayNameMap, lineOfCoverageDetailsRecords: __spreadArray(__spreadArray([], newLineOfCoverageDetailsRecords), lineOfCoverageDetailsRecords) });
    }
    if (action.type === types_1.LineOfCoverageDetailsEditorActionType.REMOVE_LINE_OF_COVERAGE_DETAILS) {
        var lineOfCoverageTypeFrequencyMap = state.lineOfCoverageTypeFrequencyMap, lineOfCoverageDetailsRecords = state.lineOfCoverageDetailsRecords, lineOfCoverageTypeDisplayNameMap = state.lineOfCoverageTypeDisplayNameMap;
        var identifier = action.payload.identifier;
        return __assign(__assign({}, state), { lineOfCoverageDetailsRecords: removeAtIdentifier(lineOfCoverageDetailsRecords, identifier, lineOfCoverageTypeFrequencyMap, lineOfCoverageTypeDisplayNameMap) });
    }
    if (action.type === types_1.LineOfCoverageDetailsEditorActionType.UPDATE_LINE_OF_COVERAGE_DETAILS) {
        var lineOfCoverageDetailsRecords = state.lineOfCoverageDetailsRecords, lineOfCoverageTypeDisplayNameMap = state.lineOfCoverageTypeDisplayNameMap;
        var _a = action.payload, identifier = _a.identifier, lineOfCoverageDetails = _a.lineOfCoverageDetails;
        return __assign(__assign({}, state), { lineOfCoverageDetailsRecords: updateByIdentifier(lineOfCoverageDetailsRecords, identifier, lineOfCoverageDetails, lineOfCoverageTypeDisplayNameMap) });
    }
    return state;
}
exports.reducer = reducer;
function updateByIdentifier(records, identifier, updatedFields, displayNameMap) {
    var index = lodash_1.findIndex(records, function (record) { return record.identifier === identifier; });
    var oldDetails = records[index].lineOfCoverageDetails;
    var newDetails = __assign(__assign({}, oldDetails), updatedFields);
    var newRecords = records.slice();
    newRecords.splice(index, 1, { identifier: identifier, lineOfCoverageDetails: newDetails });
    // Remove old display name and add new display name in set
    var displayNameSet = displayNameMap.get(oldDetails.type);
    if (displayNameSet && oldDetails.displayName)
        displayNameSet.delete(oldDetails.displayName);
    if (displayNameSet && newDetails.displayName)
        displayNameSet.add(newDetails.displayName);
    return newRecords;
}
function removeAtIdentifier(records, identifier, frequencyMap, displayNameMap) {
    var newRecords = records.slice();
    var removedElement = lodash_1.remove(newRecords, function (record) { return record.identifier === identifier; })[0];
    var _a = removedElement.lineOfCoverageDetails, type = _a.type, displayName = _a.displayName;
    // Subtract type occurence by one
    var typeOccurence = frequencyMap.get(type);
    frequencyMap.set(type, typeOccurence ? typeOccurence - 1 : 0);
    // Remove display name from set
    var displayNameSet = displayNameMap.get(type);
    if (displayName && displayNameSet)
        displayNameSet.delete(displayName);
    return newRecords;
}
function getNewLineOfCoverageDetailsRecords(linesOfCoverageDetails, frequencyMap, lineOfCoverageTypeDisplayNameMap) {
    return linesOfCoverageDetails.map(function (lineOfCoverageDetails) {
        addToFrequencyMap(frequencyMap, lineOfCoverageDetails.type);
        var displayName = addDisplayName(lineOfCoverageDetails, frequencyMap, lineOfCoverageTypeDisplayNameMap);
        return {
            identifier: nanoid_1.nanoid(),
            lineOfCoverageDetails: __assign(__assign({}, lineOfCoverageDetails), { displayName: displayName }),
        };
    });
}
function addDisplayName(lineOfCoverage, frequencyMap, lineOfCoverageTypeDisplayNameMap) {
    var _a, _b;
    var displayNameSet = (_a = lineOfCoverageTypeDisplayNameMap.get(lineOfCoverage.type)) !== null && _a !== void 0 ? _a : new Set();
    var typeOccurence = frequencyMap.get(lineOfCoverage.type);
    if (!typeOccurence || typeOccurence < 2) {
        return '';
    }
    var displayName = (_b = lineOfCoverage.displayName) !== null && _b !== void 0 ? _b : getUniqueDisplayName(typeOccurence, displayNameSet);
    if (displayName !== '')
        displayNameSet.add(displayName);
    return displayName;
}
function getUniqueDisplayName(counter, displayNameSet) {
    var displayName = "" + counter;
    if (counter === MAX_TYPE_FREQUENCY_INCREMENT) {
        return displayName;
    }
    if (displayNameSet.has(displayName)) {
        return getUniqueDisplayName(counter + 1, displayNameSet);
    }
    return displayName;
}
function addToFrequencyMap(map, key) {
    var typeOccurence = map.get(key);
    return map.set(key, typeOccurence ? typeOccurence + 1 : 1);
}
